"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrderShippingSignifydSchema = void 0;
exports.UpdateOrderShippingSignifydSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        OrderNumber: {
            type: 'string',
            minLength: 1,
        },
        StreetName: {
            type: 'string',
        },
        StreetPrefixName: {
            type: 'string',
        },
        AdditionalStreetPrefixName: {
            type: 'string',
        },
        PostalCode: {
            type: 'string',
        },
        Region: {
            type: 'string',
        },
        CityName: {
            type: 'string',
        },
        Country: {
            type: 'string',
        },
        SalesChannelName: {
            type: 'string',
            minLength: 1,
        },
    },
    required: [
        'OrderNumber',
        'StreetName',
        'PostalCode',
        'CityName',
        'Country',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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